module.exports = __webpack_public_path__ + "img/intelite.b2a2b951.png";